var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4032 8.83752L29.6341 10.2485C31.4516 12.285 32.4204 14.8791 32.3587 17.5436C32.2969 20.2081 31.2089 22.7596 29.2988 24.7188L30.9985 26.25C33.2921 23.899 34.599 20.8365 34.6735 17.6381C34.7481 14.4397 33.5851 11.3256 31.4032 8.88127V8.83752Z",
    fill: "#0164FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9523 13.125C26.0424 14.3479 26.6229 15.9053 26.5846 17.5045C26.5462 19.1037 25.8918 20.6346 24.7441 21.8094L26.4438 23.2969C27.9734 21.7289 28.8446 19.6862 28.8936 17.5531C28.9426 15.42 28.1659 13.3435 26.7098 11.7141L24.9523 13.125Z",
    fill: "#0164FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 32.8127C20.6595 32.8121 20.5082 32.7828 20.3673 32.7264C20.2264 32.6701 20.0986 32.5879 19.9916 32.4846L11.1809 24.0627H3.46875C3.16209 24.0627 2.868 23.9474 2.65116 23.7423C2.43432 23.5372 2.3125 23.259 2.3125 22.9689V12.0314C2.3125 11.7414 2.43432 11.4632 2.65116 11.258C2.868 11.0529 3.16209 10.9377 3.46875 10.9377H11.1809L19.9916 2.51581C20.2082 2.3121 20.5013 2.19775 20.8067 2.19775C21.1122 2.19775 21.4052 2.3121 21.6219 2.51581C21.8397 2.71775 21.9644 2.99294 21.9688 3.28143V31.7189C21.9688 32.009 21.8469 32.2872 21.6301 32.4923C21.4133 32.6974 21.1192 32.8127 20.8125 32.8127Z",
    fill: "#0164FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.feca7eb3.svg";
export { ForwardRef as ReactComponent };